module.exports = __webpack_public_path__ + "884e278b451159a83d73e5879d6600d5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/clever-share.png
// module id = 1659
// module chunks = 0